import { blueGrey } from '@mui/material/colors';
import type { Components, Theme } from '@mui/material/styles';

const MuiAccordion: Components<Theme>['MuiAccordion'] = {
  styleOverrides: {
    /**
     * Корневые стили табов
     * @param root0 Пропсы
     * @param root0.theme Тема
     */
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderL, // Скругленные углы
      borderWidth: 1,
      borderColor: blueGrey[50],
      borderStyle: 'solid',
      boxShadow: 'none',
      ':last-of-type': {
        borderRadius: theme.shape.borderL
      },
      ':first-of-type': {
        borderRadius: theme.shape.borderL
      },
      '&:before': {
        display: 'none' // Убираем линию перед элементом
      },
      '&.Mui-expanded': {
        margin: 0 // Убираем отступ при раскрытии
      }
    })
  }
};

const MuiAccordionSummary: Components<Theme>['MuiAccordionSummary'] = {
  styleOverrides: {
    /**
     * Корневые стили заголовка аккордеона
     * @param root0 Пропсы
     * @param root0.theme Тема
     */
    root: ({ theme }) => ({
      // 24px на телефоне: вместе с паддингом карточки строка чекбокса сжималась
      // до 67% ширины экрана и подписи переносились. От sm — прежние 24px.
      padding: 12,
      [theme.breakpoints.up('sm')]: {
        padding: 24
      }
    }),
    content: {
      margin: 0,
      '&.Mui-expanded': {
        margin: 0
      }
    }
  }
};

const MuiAccordionDetails: Components<Theme>['MuiAccordionDetails'] = {
  styleOverrides: {
    /**
     * Корневые стили тела аккордеона
     * @param root0 Пропсы
     * @param root0.theme Тема
     */
    root: ({ theme }) => ({
      padding: '0 12px 12px',
      [theme.breakpoints.up('sm')]: {
        padding: '0 24px 24px'
      }
    })
  }
};

export const accordion = {
  MuiAccordion,
  MuiAccordionSummary,
  MuiAccordionDetails
};
